// Filter IDs may be in the format <categoryID>:<filterID>, if the filters were
// requested via a route/category query. This method strips the categoryID, so
// that filter IDs are consistent
function stripCategoryId(id) {
    return id.replace(/(.+):/i, '');
}
export default stripCategoryId;
//# sourceMappingURL=stripCategoryId.js.map